export default __webpack_public_path__ + "static/media/Group 805@2x.3cb256cb.jpg";